import React, {
   forwardRef,
   useEffect,
   useImperativeHandle,
   useState
} from 'react'
import { makeStyles } from '@material-ui/core/styles'
import InfoIcon from '@material-ui/icons/Info'
import 'date-fns'
import DateFnsUtils from '@date-io/date-fns'
import {
   MuiPickersUtilsProvider,
   KeyboardDatePicker
} from '@material-ui/pickers'
import esLocale from 'date-fns/locale/es'
import './formStyle.css'
import moment from 'moment'
import {
   Typography,
   Button,
   FormControl,
   InputLabel,
   Select,
   InputAdornment,
   IconButton,
   OutlinedInput,
   Tooltip,
   MenuItem,
   FormHelperText,
   Grid
} from '@material-ui/core'
import { OPERACIONES_ROLES, REGEXP } from 'utils/constants'
import Utils from 'utils/utils'
import { useHasOperation } from 'hooks/useHasOperation'

const useStyles = makeStyles(theme => ({
   container: {
      padding: '0px 10px 10px'
   },
   formContainer: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      alignItems: 'center',
      width: '95%',
      margin: '0 auto 10px'
   },
   formControl: {
      width: '100%',
      height: 48,
      minWidth: 120,
      textAlign: 'initial',
      fontSize: '14px',
      '&:not(:first-child)': {
         marginTop: '20px'
      }
   },
   formControlTextArea: {
      width: '100%',
      height: '105px',
      minWidth: 120,
      textAlign: 'initial',
      fontSize: '14px',
      '&:not(:first-child)': {
         marginTop: '20px'
      }
   },
   button: {
      width: '100%',
      height: '40px',
      marginTop: '20px',
      color: 'white',
      background: '#3264DC'
   },
   titleOne: {
      margin: '20px 0 15px 9px',
      fontStyle: 'normal',
      fontSize: 14,
      color: '#8A8FAB',
      fontWeight: 400
   },
   disabledButton: {
      backgroundColor: '#12B3F9!important',
      opacity: '0.3',
      color: '#fff!important'
   },
   helperText: {
      marginLeft: '0px',
      marginRight: '0px',
      marginTop: '0px',
      fontSize: '11px',
      color: '#F44336'
   }
}))

const RoleForm = forwardRef(
   (
      {
         onData,
         toSearch = () => {},
         formData,
         handleInputChange,
         setForm,
         reset,
         formBehavior,
         editRoleAction
      },
      ref
   ) => {
      const classes = useStyles()
      const [isSearch, setIsSearch] = useState(false)
      const [inputsValidation, setInputsValidation] = useState({
         name: false,
         description: false,
         status: false,
         initialDate: false,
         finalDate: false,
         domain: false
      })
      const [submittedForm, setSubmittedForm] = useState(false)

      const CONSULTAR_ROL = useHasOperation(OPERACIONES_ROLES.CONSULTAR)
      const REGISTRAR_ROL = useHasOperation(OPERACIONES_ROLES.REGISTRAR)

      useEffect(() => {
         const namePath = window.location.pathname.slice(
            window.location.pathname.lastIndexOf('/') + 1,
            window.location.pathname.length
         )
         setIsSearch(namePath === 'search')
      }, [])

      useEffect(() => {
         if (formBehavior.search) {
            return
         }
         if (submittedForm) {
            isValidForm()
         } else {
            validateSaveRole()
         }
      }, [formData])

      useEffect(() => {
         if (formData.domain) {
            setInputsValidation(oldData => ({
               ...oldData,
               domain: false
            }))
         }
      }, [formData.domain])

      const isValidForm = () => {
         const inputsValidation = {
            name:
               formData.name.trim().length > 25 ||
               formData.name.trim().length === 0 ||
               !REGEXP.VALIDATION_NAME_WHIT_NUMBER.exec(formData.name),
            description:
               formData.description.trim().length > 250 ||
               formData.description.trim().length === 0,
            status:
               !formBehavior.register && formData.status.trim().length === 0,
            domain: formData.domain.trim().length === 0
         }

         setInputsValidation(inputsValidation)

         for (const prop in inputsValidation) {
            if (inputsValidation[prop] === true) {
               return false
            }
         }
         return true
      }

      const validateSaveRole = () => {
         if (formData.name.length > 25) {
            setDataCondition('name', true)
         } else if (formData.name.length > 0) {
            setDataCondition('name', false)
         }
         if (formData.description.length > 250) {
            setDataCondition('description', true)
         } else if (formData.description.length > 0) {
            setDataCondition('description', false)
         }
         !new RegExp(REGEXP.VALIDATION_NAME_WHIT_NUMBER).test(formData.name)
            ? setDataCondition('name', true)
            : setDataCondition('name', false)
      }

      const setDataCondition = (property, condition) => {
         setInputsValidation({
            ...inputsValidation,
            [property]: condition
         })
      }

      const searchRoleBtn = () => {
         toSearch({
            name: formData.name,
            domain: formData.domain,
            initialDate: moment(formData.initialDate).isValid()
               ? moment(formData.initialDate).format('YYYY-MM-DD')
               : '',
            finalDate: moment(formData.finalDate).isValid()
               ? moment(formData.finalDate).format('YYYY-MM-DD')
               : '',
            status: formData.status,
            query: '',
            order: 'ASC',
            page: 0,
            size: 5,
            columnOrder: 'name'
         })
      }

      const saveRoleBtn = () => {
         setSubmittedForm(true)
         if (isValidForm()) {
            onData({
               ...formData,
               initialDate: moment().format('YYYY-MM-DD'),
               finalDate: moment(formData.finalDate).isValid()
                  ? moment(formData.finalDate).format('YYYY-MM-DD')
                  : null
            })
         }
      }

      useImperativeHandle(ref, () => ({
         resetForm() {
            reset()
         }
      }))

      const useStylesBootstrap = makeStyles(theme => ({
         arrow: {
            color: theme.palette.secondary.main
         },
         tooltip: {
            backgroundColor: theme.palette.secondary.main
         }
      }))

      const BootstrapTooltip = props => {
         const classes = useStylesBootstrap()
         return <Tooltip placement="top" arrow classes={classes} {...props} />
      }

      const submitForm = () => {
         if (formBehavior.search) {
            searchRoleBtn()
         }
         if (formBehavior.register) {
            saveRoleBtn()
         }
         if (formBehavior.edit) {
            editRoleAction(formData)
         }
      }

      return (
         <Grid container className={classes.container}>
            <Typography className={classes.titleOne}>
               {formBehavior.search && <strong>Completa los filtros</strong>}
               {formBehavior.register && <strong>Completa los campos</strong>}
               {formBehavior.edit && (
                  <strong>Completa los campos a editar</strong>
               )}
            </Typography>
            <form className={classes.formContainer}>
               <FormControl
                  required={formBehavior.register || formBehavior.edit}
                  variant="outlined"
                  size="small"
                  className={classes.formControl}
               >
                  <InputLabel
                     htmlFor="outlined-adornment-amount"
                     error={inputsValidation.name}
                  >
                     Nombre de rol
                  </InputLabel>
                  <OutlinedInput
                     error={inputsValidation.name}
                     value={formData.name}
                     onChange={Utils.convertInputValueToUpperCase(
                        handleInputChange
                     )}
                     label="Nombre de rol"
                     name="name"
                     size="small"
                     autoComplete="off"
                     endAdornment={
                        inputsValidation.name &&
                        formData.name.trim().length > 25 && (
                           <BootstrapTooltip title="Máximo 25 caracteres">
                              <InputAdornment position="end">
                                 <IconButton
                                    aria-label="toggle password visibility"
                                    edge="end"
                                    color={
                                       inputsValidation.name ? 'secondary' : ''
                                    }
                                    style={{ marginRight: '3px' }}
                                 >
                                    <InfoIcon fontSize="small" />
                                 </IconButton>
                              </InputAdornment>
                           </BootstrapTooltip>
                        )
                     }
                  />
                  {inputsValidation.name && (
                     <FormHelperText className={classes.helperText}>
                        {!formData.name
                           ? 'El Campo nombre es Obligatorio'
                           : 'Nombre de rol inválido'}
                     </FormHelperText>
                  )}
               </FormControl>
               {(formBehavior.register || formBehavior.edit) && (
                  <FormControl
                     required={formBehavior.register}
                     variant="outlined"
                     size="small"
                     className={classes.formControlTextArea}
                  >
                     <InputLabel
                        htmlFor="outlined-adornment-amount"
                        error={inputsValidation.description}
                     >
                        Descripción del rol
                     </InputLabel>
                     <OutlinedInput
                        error={inputsValidation.description}
                        multiline={true}
                        rows={4}
                        value={formData.description}
                        onChange={handleInputChange}
                        label="Descripción del Rol"
                        name="description"
                        size="small"
                        inputProps={{ maxLength: 251 }}
                        endAdornment={
                           inputsValidation.description && (
                              <BootstrapTooltip title="Máximo 250 caracteres">
                                 <InputAdornment position="end">
                                    <IconButton
                                       aria-label="toggle password visibility"
                                       edge="end"
                                       color={
                                          inputsValidation.description
                                             ? 'secondary'
                                             : ''
                                       }
                                       style={{ marginRight: '3px' }}
                                    >
                                       <InfoIcon fontSize="small" />
                                    </IconButton>
                                 </InputAdornment>
                              </BootstrapTooltip>
                           )
                        }
                     />
                     <FormHelperText className={classes.helperText}>
                        {inputsValidation.description &&
                           (formData.description.length > 250
                              ? 'La descripción excede el máximo permitido 250 carácteres.'
                              : 'La descripción es requerida')}
                     </FormHelperText>
                  </FormControl>
               )}
               {!formBehavior.register && (
                  <FormControl
                     required={formBehavior.register}
                     variant="outlined"
                     size="small"
                     className={classes.formControl}
                  >
                     <InputLabel
                        error={inputsValidation.status}
                        htmlFor="demo-simple-select-outlined-label"
                     >
                        Estado del rol
                     </InputLabel>
                     <Select
                        labelId="demo-simple-select-outlined-label"
                        id="status"
                        disabled={formBehavior.register}
                        value={formData.status}
                        onChange={handleInputChange}
                        label="Estado del Rol"
                        name="status"
                        error={inputsValidation.status}
                     >
                        <MenuItem value="A">Activo</MenuItem>
                        <MenuItem value="I">Inactivo</MenuItem>
                     </Select>
                     <FormHelperText className={classes.helperText}>
                        {inputsValidation.status && 'El estado es requerido'}
                     </FormHelperText>
                  </FormControl>
               )}
               <FormControl
                  required={formBehavior.register}
                  variant="outlined"
                  size="small"
                  className={classes.formControl}
               >
                  <MuiPickersUtilsProvider
                     utils={DateFnsUtils}
                     locale={esLocale}
                  >
                     <KeyboardDatePicker
                        autoOk
                        size="small"
                        variant="inline"
                        inputVariant="outlined"
                        label={!formData.finalDate && 'Vigencia final'}
                        name="finalDate"
                        format="dd-MM-yyyy"
                        minDate={
                           formBehavior.search
                              ? new Date(formData.initialDate)
                              : new Date()
                        }
                        minDateMessage={`La fecha final no puede ser inferior a la fecha ${
                           formBehavior.search && formData.initialDate
                              ? 'inicial'
                              : 'actual'
                        }`}
                        invalidDateMessage=""
                        value={formData.finalDate ? formData.finalDate : null}
                        InputAdornmentProps={{ position: 'end' }}
                        onChange={e => {
                           const input = e?.target?.value
                           if (
                              /^[0-9\b]+$/.test(input) ||
                              moment(input).isValid()
                           ) {
                              setForm('finalDate', moment(e).format())
                           }
                        }}
                        autoComplete="off"
                        error={inputsValidation.finalDate}
                     />
                  </MuiPickersUtilsProvider>
               </FormControl>

               <FormControl
                  required
                  variant="outlined"
                  size="small"
                  className={classes.formControl}
               >
                  <InputLabel
                     error={inputsValidation.domain}
                     htmlFor="demo-simple-select-outlined-label"
                  >
                     Dominio
                  </InputLabel>
                  <Select
                     labelId="demo-simple-select-outlined-label"
                     id="domain"
                     value={formData.domain}
                     onChange={handleInputChange}
                     label="Dominio"
                     name="domain"
                     error={inputsValidation.domain}
                  >
                     <MenuItem value="PRIVATE">Privado</MenuItem>
                     <MenuItem value="EXTERNAL">Externo</MenuItem>
                     <MenuItem value="EXTENDED">Extendido</MenuItem>
                  </Select>
                  <FormHelperText className={classes.helperText}>
                     {inputsValidation.domain && 'El dominio es requerido'}
                  </FormHelperText>
               </FormControl>

               <Button
                  type="button"
                  fullWidth
                  variant="contained"
                  color="primary"
                  className={classes.button}
                  classes={{ disabled: classes.disabledButton }}
                  onClick={submitForm}
                  disableElevation
                  disabled={formBehavior.search ? !CONSULTAR_ROL : !REGISTRAR_ROL}
               >
                  {formBehavior.register && 'GUARDAR'}
                  {formBehavior.search && 'CONSULTAR'}
                  {formBehavior.edit && 'EDITAR'}
               </Button>
            </form>
         </Grid>
      )
   }
)

export default RoleForm
